(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('cart-drawer').forEach((drawer) => {
    drawer.addEventListener('click', (event) => {
      const minusBtn = event.target.closest('.cart-drawer__quantity-btn--minus');
      const plusBtn = event.target.closest('.cart-drawer__quantity-btn--plus');
      if (!minusBtn && !plusBtn) return;

      const selector = event.target.closest('.cart-drawer__quantity-selector');
      const input = selector?.querySelector('.cart-drawer__quantity-input');
      if (!input) return;

      const min = parseInt(input.min, 10) || 0;
      const value = parseInt(input.value, 10) || 0;

      if (minusBtn && value > min) {
        input.value = value - 1;
      } else if (plusBtn) {
        input.value = value + 1;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
